import { useSearchParams } from 'react-router-dom';

const PRODUCTS = {
  resolve: {
    id: 'resolve',
    label: 'CASA FÁCIL RESOLVE'
  },
  'resolve-mais': {
    id: 'resolve-mais',
    label: 'CASA FÁCIL RESOLVE MAIS'
  }
};

/**
 * Returns the Casa Fácil product encoded in a file name, or null for other uploads.
 */
export function casaFacilProductFromName(name) {
  const text = String(name || '').toUpperCase();
  if (
    text.includes('RESOLVE-MAIS')
    || text.includes('RESOLVE_MAIS')
    || text.includes('RESOLVEMAIS')
    || (text.includes('RESOLVE') && text.includes('MAIS'))
  ) {
    return PRODUCTS['resolve-mais'];
  }
  if (text.includes('CASA') && (text.includes('RESOLVE') || text.includes('FACIL') || text.includes('FÁCIL'))) {
    return PRODUCTS.resolve;
  }
  return null;
}

/**
 * Returns the product selected in the page query, such as ?product=resolve-mais.
 */
export function casaFacilProductById(productId) {
  return PRODUCTS[productId] || null;
}

/**
 * Reads the product query used by the Casa Fácil pages.
 */
export function useCasaFacilProduct() {
  const [params] = useSearchParams();
  return casaFacilProductById(params.get('product'));
}
